<template>
  <div>
    <div class="text-right mt-4">
      <v-btn
        class="text-none filter-toggle-button"
        depressed
        large
        color="#006CA1"
        dark
        @click="toggleShowFilters()"
      >
        <v-icon small class="mr-2">fa-light fa-filter</v-icon>
        <span class="mr-2">Filters</span>
        <v-chip
          class="mr-2"
          x-small
          :color="lengthOfSelectedFilters > 0 ? '#edcebe' : 'white'"
        >
          <span
            class="font-weight-bold"
            :style="lengthOfSelectedFilters > 0 ? 'color:#c4622d' : 'color:#006CA1'"
          >
            {{ lengthOfSelectedFilters }}
          </span>
        </v-chip>
        <v-icon small v-if="showFilters">fa-chevron-up</v-icon>
        <v-icon small v-else>fa-chevron-down</v-icon>
      </v-btn>
    </div>
    <div v-if="showFilters" :class="showFilters ? 'mb-4' : 'mb-0'">
      <v-card outlined v-if="showFilters" elevation="0" class="pa-3">
        <div class="align-center">
          <div class="d-flex flex-wrap">
            <div v-for="(filter, index) in filters" :key="index" v-if="filter.selected">
              <v-menu
                :close-on-content-click="false"
                offset-y
                v-model="filter.menuModel"
                :max-width="
                  filter.type === 'select'
                    ? Math.min(viewportWidth, 500)
                    : filter.type === 'multiSelect'
                    ? Math.min(viewportWidth, 205)
                    : filter.type === 'date'
                    ? Math.min(viewportWidth, 560)
                    : Math.min(viewportWidth, 300)
                "
                :min-width="
                  filter.type === 'date'
                    ? Math.min(viewportWidth, 560)
                    : filter.type === 'textField'
                    ? Math.min(viewportWidth, 600)
                    : 'auto'
                "
              >
                <template v-slot:activator="{ attrs, on }">
                  <div class="mr-4 mb-2 d-flex align-center">
                    <div
                      class="d-flex filter-activator-button"
                      v-ripple
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="
                        filter.type === 'soloCheckBox'
                          ? changeSoloCheckBoxStatus(filter)
                          : ''
                      "
                    >
                      <div style="color: #3f4757; font-weight: 500; margin-right: 10px">
                        {{ filter.title }}
                      </div>

                      <div class="three-dots" v-if="filter.type === 'textField'">
                        <span
                          class="text-color"
                          v-if="filter.id === 'officer' && filter.value === ''"
                          >All</span
                        >
                        <span
                          v-else-if="filter.id === 'validity' && filter.value === ''"
                          class="text-color"
                          >All</span
                        >
                        <span
                          v-else-if="
                            filter.id === 'validity' && filter.value === 'always'
                          "
                          class="text-color"
                          >Always</span
                        >
                        <span v-else-if="filter.value === ''" class="grey--text caption"
                          >empty</span
                        >
                        <span
                          v-else-if="
                            filter.id === 'validity' && filter.dropDownModel === 'Limited'
                          "
                        >
                          <span class="grey--text caption mr-2">{{
                            filter.dropDownModel
                          }}</span>
                          <span class="text-color">{{ filter.value }}</span>
                          <span class="text-color"> days</span>
                        </span>
                        <span v-else>
                          <span class="grey--text caption mr-2">{{
                            filter.dropDownModel
                          }}</span>
                          <span
                            v-if="
                              filter.dropDownModel !== 'Always' &&
                              filter.dropDownModel !== 'All'
                            "
                            class="text-color"
                            >{{ filter.value }}</span
                          >
                        </span>
                      </div>
                      <div class="three-dots" v-if="filter.type === 'soloCheckBox'">
                        <v-icon
                          color="#006CA1"
                          class="mr-2 dots-status"
                          small
                          v-if="filter.status === 'All'"
                          >fa-light fa-square</v-icon
                        >
                        <v-icon
                          color="#006CA1"
                          class="mr-2 dots-status"
                          small
                          v-else-if="filter.status === 'Yes'"
                          >fa-solid fa-square-check</v-icon
                        >
                        <v-icon
                          color="#006CA1"
                          class="mr-2 dots-status"
                          small
                          v-else-if="filter.status === 'No'"
                          >fa-solid fa-square-xmark</v-icon
                        >
                        {{ filter.status }}
                      </div>
                      <div class="three-dots" v-if="filter.type === 'multiSelect'">
                        <span
                          class="text-color"
                          v-if="
                            filter.id === 'status' &&
                            !filter.items.some((fil) => fil.selected)
                          "
                          >All</span
                        >
                        <span
                          v-else-if="!filter.items.some((fil) => fil.selected)"
                          class="grey--text caption"
                          >empty</span
                        >
                        <span
                          v-for="(item, index) in filter.items"
                          :key="index"
                          v-if="item.selected"
                        >
                          <v-chip
                            style="cursor: pointer"
                            class="mr-1"
                            small
                            color="#DCE0F5FF"
                          >
                            <span
                              style="
                                color: #006ca1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                              "
                              >{{ item.title }}</span
                            >
                          </v-chip>
                        </span>
                      </div>
                      <div class="three-dots" v-if="filter.type === 'autocomplete'">
                        <span v-if="!filter.value" class="grey--text caption">empty</span>
                        <span class="text-color" v-else>{{ filter.value }}</span>
                      </div>
                      <div class="three-dots" v-if="filter.type === 'select'">
                        <span
                          class="text-color"
                          v-if="filter.id === 'subjectType' && filter.value === ''"
                          >End Entity</span
                        >
                        <span
                          v-else-if="filter.id === 'status' && filter.value === ''"
                          class="text-color"
                          >All</span
                        >
                        <span class="text-color" v-else>{{ filter.value }}</span>
                      </div>

                      <div class="three-dots" v-if="filter.type === 'date'" :key="filter.dateFrom + filter.dateTo">
                        <span
                          v-if="!filter.valueDescription?.length"
                          class="grey--text caption"
                        >
                          empty
                        </span>
                        <span
                          v-show="filter.valueDescription.length != 0"
                          v-for="(text, index) in filter.valueDescription"
                          :class="
                            index % 2 === 0 ? 'grey--text caption mr-1' : 'text-color'
                          "
                        >
                          {{ text }}
                        </span>
                      </div>

                      <v-icon
                        x-small
                        class="ml-3"
                        v-if="filter.menuModel && filter.type !== 'soloCheckBox'"
                        >fa-chevron-up</v-icon
                      >
                      <v-icon
                        x-small
                        class="ml-3"
                        v-else-if="filter.type !== 'soloCheckBox'"
                        >fa-chevron-down</v-icon
                      >
                    </div>
                    <div v-if="!filter.required">
                      <v-btn x-small icon color="#006CA1" @click="removeFilter(filter)">
                        <v-icon>fa-light fa-circle-xmark</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </template>
                <v-card>
                  <v-container v-if="filter.type === 'textField'">
                    <div class="pa-2">
                      <v-row>
                        <v-col cols="5">
                          <v-select
                            dense
                            :menu-props="{ bottom: true, offsetY: true }"
                            :items="filter.dropDownItems"
                            item-text="name"
                            v-model="filter.dropDownModel"
                            label="Option"
                            hide-details
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            v-if="filter.id !== 'validity'"
                            v-model="filter.textFieldModel"
                            hide-details
                            dense
                            outlined
                            :label="filter.dropDownModel"
                          ></v-text-field>
                          <v-text-field
                            v-if="
                              filter.id === 'validity' &&
                              filter.dropDownModel === 'Limited'
                            "
                            v-model="filter.textFieldModel"
                            hide-details
                            dense
                            outlined
                            min="1"
                            label="Number of days"
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row justify="end" class="pt-5">
                        <v-btn
                          color="#006CA1"
                          depressed
                          outlined
                          small
                          class="mr-2 text-none"
                          @click="
                            filter.textFieldModel = '';
                            filter.value = '';
                            filter.dateFrom = '';
                            filter.dateTo = '';
                          "
                        >
                          Reset
                        </v-btn>
                        <v-btn
                          v-if="
                            filter.dropDownModel !== 'Always' &&
                            filter.dropDownModel !== 'All'
                          "
                          color="#006CA1"
                          dark
                          depressed
                          small
                          @click="
                            filter.value = filter.textFieldModel;
                            filter.menuModel = false;
                          "
                          >Set
                        </v-btn>
                        <v-btn
                          v-if="
                            filter.id === 'validity' &&
                            filter.dropDownModel === 'Always'
                          "
                          color="#006CA1"
                          dark
                          depressed
                          small
                          @click="
                            filter.value = 'always';
                            filter.textFieldModel = 'always';
                            filter.menuModel = false;
                          "
                          >Set
                        </v-btn>
                        <v-btn
                          v-if="
                            filter.id === 'validity' && filter.dropDownModel === 'All'
                          "
                          color="#006CA1"
                          dark
                          depressed
                          small
                          @click="
                            filter.value = '';
                            filter.textFieldModel = '';
                            filter.menuModel = false;
                          "
                          >Set
                        </v-btn>
                      </v-row>
                    </div>
                  </v-container>
                  <v-container v-if="filter.type === 'autocomplete'">
                    <div class="pa-2">
                      <v-row>
                        <v-col cols="9">
                          <v-autocomplete
                            v-model="filter.textFieldModel"
                            dense
                            outlined
                            :hide-no-data="true"
                            :auto-select-first="true"
                            :filter="filter.queryFilter"
                            :item-text="'title'"
                            :item-value="'id'"
                            :items="filter.items"
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row justify="end" class="pt-5">
                        <v-btn
                          color="#006CA1"
                          depressed
                          outlined
                          small
                          class="mr-2 text-none"
                          @click="
                            filter.textFieldModel = '';
                            filter.value = '';
                          "
                        >
                          Reset
                        </v-btn>
                        <v-btn
                          color="#006CA1"
                          dark
                          depressed
                          small
                          @click="
                            filter.value = filter.textFieldModel;
                            filter.menuModel = false;
                          "
                          >Set
                        </v-btn>
                      </v-row>
                    </div>
                  </v-container>
                  <v-container v-if="filter.type === 'multiSelect'">
                    <v-row>
                      <v-list>
                        <v-list-item
                          item-color="#006CA1"
                          color="#006CA1"
                          v-for="(item, index) in filter.items"
                          :key="index"
                          @click="item.selected = !item.selected"
                        >
                          <v-icon color="#006CA1" class="mr-2" v-if="item.selected"
                            >fa-solid fa-square-check</v-icon
                          >
                          <v-icon color="#006CA1" class="mr-2" v-else
                            >fa-light fa-square</v-icon
                          >
                          <v-list-item-title color="#006CA1">{{
                            item.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-row>
                  </v-container>
                  <v-container v-if="filter.type === 'select'">
                    <v-row>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in filter.items"
                          :key="index"
                          :style="item.selected ? 'background-color: #DCE0F5' : ''"
                          @click="filterWithTypeSelectIsSelected(filter, item)"
                        >
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-row>
                  </v-container>

                  <certificate-filters-dates
                    @resetAllDateModals="resetAllDateModals"
                    :filter="filter"
                  />
                </v-card>
              </v-menu>
            </div>
          </div>
          <div>
            <v-row justify="space-between" class="ma-0">
              <div>
                <v-menu :close-on-content-click="false" offset-x v-model="menu">
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      v-if="viewportWidth < 600"
                      depressed
                      v-bind="attrs"
                      dark
                      v-on="on"
                      color="#006CA1"
                      class="mt-3 text-none"
                    >
                      <v-icon class="mr-2" small>fa-plus</v-icon>
                      Add
                      <v-icon class="ml-2" small v-if="menu">fa-chevron-up</v-icon>
                      <v-icon class="ml-2" small v-else>fa-chevron-down</v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      depressed
                      v-bind="attrs"
                      dark
                      v-on="on"
                      color="#006CA1"
                      class="mt-3 text-none"
                    >
                      <v-icon class="mr-2" small>fa-plus</v-icon>
                      Add
                      <v-icon class="ml-2" small v-if="menu">fa-chevron-up</v-icon>
                      <v-icon class="ml-2" small v-else>fa-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in filters"
                      :key="index"
                      @click="itemSelected(item)"
                    >
                      <v-icon color="#006CA1" class="mr-2" v-if="item.selected"
                        >fa-solid fa-square-check</v-icon
                      >
                      <v-icon color="#006CA1" class="mr-2" v-else
                        >fa-light fa-square</v-icon
                      >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

              <div>
                <v-btn
                  @click="clearAllFilters()"
                  dark
                  depressed
                  color="#006CA1"
                  class="mr-3 mt-3 text-none"
                  outlined
                >
                  Clear all
                </v-btn>
                <v-btn
                  @click="setFiltersAndCertificates()"
                  dark
                  depressed
                  color="#006CA1"
                  class="mt-3 text-none"
                >
                  Apply
                </v-btn>
              </div>
            </v-row>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CertificateFiltersDates from "@/components/certificates/certificates-filters/certificate-filters-dates.vue";
import * as constants from "@/config/constants";

export default {
  name: "certificates-new-filters-index",
  components: { CertificateFiltersDates },
  props: ["filters", "type"],
  data() {
    return {
      viewportWidth: document.documentElement.clientWidth || document.body.clientWidth,
      showFilters: false,
      selectedFilters: [],
      menu: false,
      lastUpcomingItems: ["last", "upcoming"],
      calendricalItems: ["minutes", "days", "weeks", "month", "years"],
    };
  },
  created() {
    // const filtersLocal = JSON.parse(localStorage.getItem("filtersLocal"));
    // if (filtersLocal) {
    //   this.filters = filtersLocal;
    // }

    const showFiltersLocal = JSON.parse(localStorage.getItem("showFiltersLocal"));
    if (showFiltersLocal) {
      this.showFilters = showFiltersLocal;
    }
  },
  computed: {
    lengthOfSelectedFilters() {
      return this.filters.filter((filter) => filter.selected).length;
    },
  },
  methods: {
    ...mapActions(["updateCertificateSearchParams", "updateRegistrationSearchParams"]),
    changeSoloCheckBoxStatus(filter) {
      if (filter.status === "All") {
        filter.status = "Yes";
      } else if (filter.status === "Yes") {
        filter.status = "No";
      } else if (filter.status === "No") {
        filter.status = "All";
      }
    },
    resetAllDateModals() {
      this.$emit("resetAllDateModals");
    },
    itemSelected(item) {
      const filtersExist = this.filters.some((filter) => filter.selected);
      if (!filtersExist) {
        this.menu = false;
        setTimeout(() => {
          this.menu = true;
        }, 10);
      }
      item.selected = !item.selected;
      localStorage.setItem("filtersLocal", JSON.stringify(this.filters));
    },
    filterWithTypeSelectIsSelected(filter, item) {
      filter.items.forEach((filt) => {
        filt.selected = false;
      });
      item.selected = true;
      filter.value = item.title;
      filter.menuModel = false;
    },
    async clearAllFilters() {
      this.filters.forEach((filter) => {

        if (filter.required) {
          // Do not reset required filters
          return;
        }

        filter.value = "";

        switch (filter.type) {
          case "textField":
            filter.textFieldModel = "";
            break;
          case "date":
            filter.valueDescription = [];
            filter.dateFrom = "";
            filter.dateTo = "";
            break;
          case "multiSelect":
            filter.items.forEach((item) => {
              item.selected = false;
            });
            break;
          case "select":
            filter.items.forEach((item) => {
              item.selected = false;
            });
            break;
          case "soloCheckBox":
            filter.status = "All";
            break;
          case "autocomplete":
            filter.textFieldModel = "";
            filter.value = "";
            break;
          default:
        }

      });
      await this.setFiltersAndCertificates();
    },
    async setFiltersAndCertificates() {
      let filtersContainer = {};
      this.filters
        .filter((filter) => filter.selected || filter.required)
        .forEach((filter) => {
          if (filter.type === "textField" && filter.value) {
            if (filter.dropDownModel === "Matches") {
              filtersContainer[filter.id] = filter.value;
            } else if (filter.dropDownModel === "Contains") {
              filtersContainer[filter.id] = `%${filter.value}%`;
            } else if (filter.dropDownModel === "Starts with") {
              filtersContainer[filter.id] = `${filter.value}%`;
            } else if (filter.dropDownModel === "Ends with") {
              filtersContainer[filter.id] = `%${filter.value}`;
            } else if (filter.dropDownModel === "Limited") {
              filtersContainer[filter.id] = filter.value;
            } else if (filter.dropDownModel === "Always") {
              filtersContainer[filter.id] = filter.value;
            } else if (filter.dropDownModel === "All") {
              filtersContainer[filter.id] = filter.value;
            }
          }

          if (filter.type === "autocomplete" && filter.value) {
            filtersContainer[filter.id] = filter.value;
          }

          if (filter.type === "select") {
            const selectedId = filter.items.find((item) => item.selected)?.id;
            if (selectedId && selectedId !== "all") {
              filtersContainer[filter.id] = selectedId;
            }
          }

          if (filter.type === "multiSelect") {
            const selected = filter.items.filter((item) => item.selected);
            if (filter.id === "revocationReason") {
              if (selected.length) {
                // Overwrite any revocationReasons set by status=isRevoked
                filtersContainer["revocationReason"] = selected.map((item) => item.id).join(",");
              }
            } else {
              selected.forEach((item) => {
                if (filter.id === "status" && item.id === "isRevoked") {
                  // Only set revocation reasons if not already set by revocationReason filter
                  if (!filtersContainer["revocationReason"]) {
                    filtersContainer["revocationReason"] = constants.REVOCATION_REASONS.map(reason => reason.id).join(",");
                  }
                } else {
                  filtersContainer[item.id] = item.selected;
                }
              });
            }
          }

          if (filter.type === "date") {
            filtersContainer = { ...filter.value, ...filtersContainer };
          }

          if (
            filter.type === "soloCheckBox" &&
            filter.status &&
            filter.status !== "All"
          ) {
            filtersContainer[filter.id] =
              filter.status === "Yes" ? true : filter.status === "No" ? false : "";
          }
        });

      if (this.type === "certificates") {
        filtersContainer.searchOffset = 1;
        await this.updateCertificateSearchParams(filtersContainer);
      } else if (this.type === "registrations") {
        await this.updateRegistrationSearchParams(filtersContainer);
      }
    },
    setCalenderValue(filter) {
      if (
        filter.models.betweenOneDateModel === "" &&
        filter.models.betweenTwoDateModel === "" &&
        filter.models.beforeDateModel === "" &&
        filter.models.afterDateModel === "" &&
        filter.models.withinIntervalNumberModel === ""
      ) {
        filter.menuModel = false;
      } else {
        filter.menuModel = false;
        switch (filter.radioGroup) {
          case 1:
            filter.value = `Within ${filter.models.withinLastUpcomingModel} ${filter.models.withinIntervalNumberModel} ${filter.models.withinCalendricalModel}`;
            break;
          case 2:
            filter.value = `Before ${filter.models.beforeDateModel}`;
            break;
          case 3:
            filter.value = `After ${filter.models.afterDateModel}`;
            break;
          case 4:
            filter.value = `Between ${filter.models.betweenOneDateModel} and ${filter.models.betweenTwoDateModel}`;
            break;
          default:
        }
      }
    },
    clearOtherModels(filter, activeRadio) {
      switch (activeRadio) {

        case 1:
          filter.models.betweenOneDateModel = "";
          filter.models.betweenTwoDateModel = "";
          filter.models.beforeDateModel = "";
          filter.models.afterDateModel = "";

          break;
        case 2:
          filter.models.withinIntervalNumberModel = "";
          filter.models.betweenOneDateModel = "";
          filter.models.betweenTwoDateModel = "";
          filter.models.afterDateModel = "";

          break;
        case 3:
          filter.models.withinIntervalNumberModel = "";
          filter.models.betweenOneDateModel = "";
          filter.models.betweenTwoDateModel = "";
          filter.models.beforeDateModel = "";

          break;
        case 4:
          filter.models.withinIntervalNumberModel = "";
          filter.models.beforeDateModel = "";
          filter.models.afterDateModel = "";

          break;
        default:
      }
    },
    clearCalenderValue(filter) {
      filter.models.betweenOneDateModel = "";
      filter.models.betweenTwoDateModel = "";
      filter.models.beforeDateModel = "";
      filter.models.afterDateModel = "";
      filter.models.withinIntervalNumberModel = "";
      filter.value = "";
    },
    toggleShowFilters() {
      this.showFilters = !this.showFilters;
      localStorage.setItem("showFiltersLocal", JSON.stringify(this.showFilters));
    },
    removeFilter(filter) {
      filter.selected = false;
      filter.value = "";

      switch (filter.type) {
        case "textField":
          filter.textFieldModel = "";
          break;
        case "date":
          filter.valueDescription = [];
          filter.dateFrom = "";
          filter.dateTo = "";
          break;
        case "multiSelect":
          filter.items.forEach((item) => {
            item.selected = false;
          });
          break;
        case "select":
          filter.items.forEach((item) => {
            item.selected = false;
          });
          break;
        case "soloCheckBox":
          filter.status = "All";
          break;
      }
      localStorage.setItem("filtersLocal", JSON.stringify(this.filters));
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-list-item--link::before {
  background-color: #006ca1;
}

::v-deep .theme--light.v-list-item:hover::before {
  opacity: 0.3;
}

.text-color {
  color: #006ca1;
}
.filter-activator-button:hover {
  background-color: #f1f1f1;
}

.filter-toggle-button {
  border-radius: 15px 15px 0 0 !important;
}

.dots-status {
  margin-top: -3px;
}
.filter-activator-button {
  //max-width: 500px;
  //text-overflow: ellipsis;
  //overflow: hidden;
  //white-space: nowrap;
  background-color: #f8f9fa;
  padding: 6px 10px 6px 10px;
  border-radius: 8px;
  margin-right: 2px;
}
.three-dots {
  color: #652cb3;
  max-width: 19rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.v-list-item {
  min-height: 2rem;
  max-height: 4rem;
  max-width: 14rem;
}

@media only screen and (max-width: 600px) {
  .three-dots {
    max-width: 9rem !important;
    min-width: 0rem !important;
  }
  .filter-activator-button {
    font-size: 0.875rem;
  }
  ::v-deep .v-chip.v-size--small {
    max-width: 3.75rem;
  }
}
</style>
